import React, { useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { MoreVertical } from "react-feather";
import BackLink from "../../../components/BackLink";
import InviteSchoolAdministrator from "./InviteSchoolAdministrator";
import { GET_FRANCHISE_ADMINS } from "../services/graphql";
import styles from "../Franchises.module.scss";

const FranchiseAdmins = ({ franchiseId }) => {
  const [showInvite, setShowInvite] = useState(false);
  const [refreshError, setRefreshError] = useState("");
  const { data, loading, error, refetch } = useQuery(GET_FRANCHISE_ADMINS, {
    variables: { franchiseId },
    fetchPolicy: "no-cache"
  });
  const franchise = data && data.franchise;
  const memberships = (franchise && franchise.memberships) || [];

  return (
    <div className={styles.franchises}>
      <BackLink text={franchise ? `${franchise.name} franchise` : "Franchise"} to={`/franchises/${franchiseId}`} />
      {loading && <p role="status">Loading franchise administrators...</p>}
      {error && <p role="alert">Unable to load franchise administrators. Please try again later.</p>}
      {!loading && !error && !franchise && <p>Franchise not found.</p>}
      {!loading && !error && franchise && <>
        <div className={`${styles.detailHeader} ${styles.header}`}>
          <div>
            <h1 className="title">Franchise administrators</h1>
            <p>View administrator memberships for {franchise.name}.</p>
          </div>
          <button type="button" className={styles.primaryButton} onClick={() => setShowInvite(true)}>Invite admin</button>
        </div>

        {refreshError && <p role="alert">{refreshError}</p>}
        {showInvite && <InviteSchoolAdministrator franchiseId={franchiseId} franchiseAdmin closeModal={() => setShowInvite(false)} onInvited={() => {
          setShowInvite(false);
          setRefreshError("");
          refetch().catch(() => setRefreshError("Administrator added, but the list could not be refreshed. Please reload the page."));
        }} />}

        <div className={styles.adminAccountsSummary}>
          <strong>{memberships.length}</strong>
          <div>
            <h3>administrator accounts</h3>
            <p>{franchise.name} franchise</p>
          </div>
        </div>

        <div className={styles.section}>
          <h2>All franchise administrators</h2>
          {memberships.length === 0 ? <p>No franchise administrators.</p> : <ul className={styles.schoolAdminList}>
            {memberships.map(membership => {
              const name = membership.userName || "—";
              const initials = (membership.userName || "").trim().split(/\s+/).filter(Boolean).map(part => part.charAt(0)).slice(0, 2).join("");
              return (
                <li key={membership.id} data-status={(membership.statusLabel || "").toLowerCase()}>
                  <div className={styles.schoolAdminIdentity}>
                    <span className={styles.addIcon}>{initials || "—"}</span>
                    <div>
                      <h3>{name}</h3>
                      <p>Franchise administrator</p>
                    </div>
                  </div>
                  <p>{membership.activityLabel || "—"}</p>
                  <strong className={styles.schoolAdminStatus}>{membership.statusLabel || "—"}</strong>
                  <button type="button" className={styles.schoolAdminMenu} aria-label={`Manage ${name}`} disabled><MoreVertical size={20} /></button>
                </li>
              );
            })}
          </ul>}
        </div>
      </>}
    </div>
  );
};

export default FranchiseAdmins;
